import { IconSvg, IconSvgProps } from "./icon"

export default function PauseFill(props: IconSvgProps) {
  return (
    <IconSvg {...props} fill="currentColor" strokeWidth={0}>
      <path d="M8.143 3.643H4.929c-.71 0-1.286.575-1.286 1.286V19.07c0 .71.575 1.286 1.286 1.286h3.214c.71 0 1.286-.575 1.286-1.286V4.93c0-.71-.576-1.286-1.286-1.286ZM19.071 3.643h-3.214c-.71 0-1.286.575-1.286 1.286V19.07c0 .71.576 1.286 1.286 1.286h3.214c.71 0 1.286-.575 1.286-1.286V4.93c0-.71-.575-1.286-1.286-1.286Z" />
    </IconSvg>
  )
}
